module.exports = __webpack_public_path__ + "static/assets/659a9f7156e7605433442183c31edd8b.png";